export function sendTrack(eventName, payload) {
  if (globalThis.dataLayer) {
    // eslint-disable-next-line no-undef
    dataLayer.push({ event: eventName, ...payload });
  }

  if (globalThis.analytics) {
    // eslint-disable-next-line no-undef
    analytics.track(eventName, payload);
  }
}

if (typeof globalThis !== 'undefined') {
  globalThis.unlk = globalThis.unlk || {};
  globalThis.unlk.sendTrack = sendTrack;
}
